export default __webpack_public_path__ + "static/NWP-So-Cal-COD-Application-2022-NEW-507e61323ea97dc71f0570e1c0f629ea.pdf";